import React, { useState, useCallback } from "react";
import { faHeart, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { useSelector, useDispatch } from "react-redux";
import { offers } from "../Redux/API";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Loader from "../Loader";
import { showRegister, searsh_product } from "../Redux/HomeSlice";
import { useNavigate } from "react-router-dom";
import empty_box2 from "../images/empty_box2.svg"
import {
  product_reviews,
  product_details,
  favorites,
  addFavorite,
  remove_favorites,
} from "../Redux/API";
import { useTranslation } from "react-i18next";
import Register from "../Register/Register";
import { productDetails } from "../Redux/HomeSlice";
import Searsh from '../Searsh/Searsh'

import "./Offers.css";
import { useEffect } from "react";
import { show_brand, show_Influencer, show_store} from '../Redux/API';

function Offers() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(offers());
  }, []);

  const favorite = useSelector((state) => state?.Data?.favorites?.data?.data);
  const loadingRemove_favorites = useSelector((state) => state.Data.loadingRemove_favorites);
  const loadingAddFavorite = useSelector((state) => state.Data.loadingAddFavorite);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });

  const getLocalStorage = window.localStorage.getItem("UserInfo");
  const valueLocalStorage = getLocalStorage
    ? JSON.parse(getLocalStorage)
    : null;
  const token =
    valueLocalStorage?.data?.token ||
    valueLocalStorage?.data?.data?.user?.token ||
    null;

  const showR = useSelector((state) => state?.products?.showR);

  useEffect(() => {
    if (!loadingAddFavorite && !loadingRemove_favorites) {
      dispatch(favorites()); // قم بتحديث المفضلة بعد الإضافة أو الحذف
    }
  }, [dispatch, loadingAddFavorite, loadingRemove_favorites]);

  const handelAdd_wishlist = (id, event) => {
    if (token) {
      const isInWishlist = favorite?.some((item) => item.product_id === id);
      if (isInWishlist) {
        dispatch(remove_favorites(id));
      } else {
        dispatch(addFavorite({ id }));
      }
    } else {
      const { pageY } = event;
      const offsetY = -100; // إزاحة بسيطة لعرض الـ Popup تحت النقطة قليلاً
      setPopupPosition({ x: 50, y: pageY + offsetY }); // X في المنتصف باستخدام نسبة 50%، Y عند النقطة التي تم الضغط عليها
      dispatch(showRegister(true));
    }
  };

  const Sign_Up = (event) => {
    if (!token) {
      const { pageY } = event;
      const offsetY = -1200;
      setPopupPosition({ x: 50, y: pageY + offsetY });
      dispatch(showRegister(true));
    }
  };

  const offer = useSelector((state) => state.Data.offers);
  const loadingOffers = useSelector((state) => state.Data.loadingOffers);

  const gotoProductDetails = (product) => {
    localStorage.setItem("Product_id", product.id);
    dispatch(product_details(product.id));
    dispatch(product_reviews(product.id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));


    const id = product?.type?.id;
    if (!id || !product?.vendor_type) return;

    switch (product.vendor_type) {
      case "brand":
          localStorage.setItem('brandId', id);
          dispatch(show_brand({ id }));
          break;
      case "influencer":
          localStorage.setItem('InfluencerId', id);
          dispatch(show_Influencer({ id }));
          break;
      case "store":
          localStorage.setItem('storeId', id);
          dispatch(show_store({ id }));
          break;
      default:
          console.error("Unknown vendor type:", product.vendor_type);
    }
  };

//   const handleNavigate = () => {
//     const id = product?.type?.id;
//     if (!id || !product?.vendor_type) return;

//     switch (product.vendor_type) {
//         case "brand":
//             localStorage.setItem('brandId', id);
//             dispatch(show_brand({ id }));
//             dispatch(filter_data({influencer_id: null, brand_id: id, store_id: null}));
//             dispatch(sort_data({influencer_id: null, brand_id: id, store_id: null}));
//             break;
//         case "influencer":
//             localStorage.setItem('InfluencerId', id);
//             dispatch(show_Influencer({ id }));
//             dispatch(filter_data({influencer_id: id, brand_id: null, store_id: null}));
//             dispatch(sort_data({influencer_id: id, brand_id: null, store_id: null}));
//             break;
//         case "store":
//             localStorage.setItem('storeId', id);
//             dispatch(show_store({ id }));
//             dispatch(filter_data({influencer_id: null, brand_id: null, store_id: id}));
//             dispatch(sort_data({influencer_id: null, brand_id: null, store_id: id}));
//             break;
//         default:
//             console.error("Unknown vendor type:", product.vendor_type);
//     }
// };

  const show_searsh = useSelector((state) => state?.products?.searsh);
  const images = offer?.data?.data || [];

  return (
    <div className="offers">
      <Header />
      {showR && (
      <div className="overlay">
          <div
            className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4 mx-auto g-0"
            style={{
              position: "absolute",
              top: `${popupPosition.y}px`,
              left: "50%",
              transform: "translateX(-50%)",
              margin: "auto",
              zIndex: 4,
              padding: "0px",
            }}
          >
            <Register />
          </div>
        </div>
      )}

      {show_searsh && (
        <Searsh />
      )}
      <div className="container">

        {loadingOffers && <Loader />}
        <div className="cont row justify-content-between g-0 border-0">
          <p className="font-size2">{t("Offers")}</p>
          <div className=" col">
          {images.length == 0 && (
            <div className="empty-cart">
              <img src={empty_box2} alt="Empty Cart" />
            </div>

          )}
            <div className="gallery1 container 0 border-0">
              <div className="row_prodect row  align-items-center justify-content-around g-0 border-0">
                {images?.map((product, index) => {
                  const isInWishlist = favorite?.some(
                    (item) => item.product_id === product.id
                  );

                  return (
                    <div
                      key={index}
                      className="box col-5 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 px-lg-3 mx-lg-0 col-xl-2 mx-xl-1 px-xl-0 text-center g-0 mb-3"
                    >
                      <div className="border_box">
                        <div className="padding_box" onClick={() => gotoProductDetails(product)} >
                          <i
                            className="font-size2"
                            onClick={(event) => {
                              handelAdd_wishlist(product.id, event);
                              event.stopPropagation();
      
                            }}
                            style={{ color: isInWishlist ? "red" : "white" }}
                          >
                            <FontAwesomeIcon icon={faHeart} />
                          </i>
                          {product?.discount && (
                            <p className="discount">Off {product?.discount}</p>
                          )}
                          <img
                            src={product.main_image}
                            alt={`img-${index}`}
                          />
                          <p className="discraptoin">{product?.description}</p>
                          <div className="price align-items-center">
                            <p>{product?.new_price}</p>
                            {product?.old_price && (
                              <p className="old_price">{product?.old_price}</p>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer Sign_Up={Sign_Up} />
    </div>
  );
}

export default Offers;
